import React from 'react';
export function PainSection() {
  return <section className="py-6 px-4 bg-white border-t border-gray-100" data-id="element-96" data-mp="1rruahoo2vtz4">
      <div className="max-w-3xl mx-auto text-center md:text-left" data-id="element-97" data-mp="38wvksivkh3oh">
        

        <p className="text-xl md:text-2xl font-bold text-red-600 mb-3 text-center" data-id="element-98" data-mp="2uyfbqla8f136">
          ¿Cuántas veces necesitaste trabajar una habilidad con tus estudiantes
          y terminaste buscando actividades por todos lados?
        </p>

        <div className="text-lg text-gray-700 space-y-3 mb-4" data-id="element-99" data-mp="2l7kiuy2hd38r">
          <p className="font-bold text-gray-900" data-id="element-100" data-mp="2pzkmp1lo8gam">
            Comprensión lectora, escritura, técnicas para estudiar, pensamiento
            crítico, argumentación, organización...
          </p>
          <p data-id="element-101" data-mp="2g8pz9twovanl">
            Son habilidades que los estudiantes necesitan en prácticamente todas
            las materias, pero muchas veces no contamos con actividades
            específicas para trabajarlas.
          </p>
        </div>

        <p className="text-lg text-gray-700 font-medium" data-id="element-102" data-mp="2779qtrpfpim0">
          Y entre planificaciones, clases, correcciones y reuniones, crear
          materiales desde cero lleva tiempo que muchas veces no tenemos.
        </p>

        <p className="text-xl font-bold text-center mt-4 text-gray-900" data-id="element-103" data-mp="3nl5qe9qng4q8">
          Trabajar habilidades importantes no debería significar sumar más horas
          de planificación.
        </p>
      </div>
    </section>;
}